module.exports = __webpack_public_path__ + "img/ao.0b77a06a.svg";